const hidePhoneNumber = (phoneNumber) => {
  // 检查输入是否是数字，并且长度是否为11位
  if (/^\d{11}$/.test(phoneNumber)) {
    // 隐藏中间四位数字
    return phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
  } else {
    // 非法的手机号格式，直接返回原始输入
    return phoneNumber
  }
}

const observer = new MutationObserver(mutationsList => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  for (const mutations of mutationsList) {
    // 处理删除
    for (const node of mutations.removedNodes) {
      if (node === div) {
        setWaterMark(hidePhoneNumber(userData.userPhone), userData.userName)
      }
    }
    // 处理修改
    if (mutations.target === div) {
      setWaterMark(hidePhoneNumber(userData.userPhone), userData.userName)
    }
  }
})

let id = '1.23452384164.123412415'
let div = null

/**  水印添加方法  */
const setWatermark = (str1, str2) => {
  id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  const can = document.createElement('canvas')
  // 设置canvas画布大小
  can.width = 230
  can.height = 160

  const cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180) // 水印旋转角度
  cans.font = '16px Vedana'
  cans.fillStyle = '#cfcfcf'
  cans.textAlign = 'center'
  cans.textBaseline = 'Middle'
  cans.fillText(str1, can.width / 2, can.height) // 水印在画布的位置x，y轴
  cans.fillText(str2, can.width / 2, can.height + 22)

  div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.opacity = '0.40'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.minHeight = '1024px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)

  // 防止删除
  observer.observe(document.body, {
    attributes: true, // 属性的变动
    childList: true, // 子节点的变动（指新增，删除或者更改）
    subtree: true // 表示是否将该观察器应用于该节点的所有后代节点
  })

  return id
}

// 添加水印方法
export const setWaterMark = (str1, str2) => {
  let id = setWatermark(str1, str2)
  if (document.getElementById(id) === null) {
    id = setWatermark(str1, str2)
  }
}

// 移除水印方法
export const removeWatermark = () => {
  const id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
    observer.disconnect()
  }
}
